const acceptedItems = [
  { icon: 'ri-computer-line', label: 'Computadores y laptops' },
  { icon: 'ri-smartphone-line', label: 'Celulares y tablets' },
  { icon: 'ri-printer-line', label: 'Impresoras y escáneres' },
  { icon: 'ri-tv-line', label: 'Televisores y monitores' },
  { icon: 'ri-keyboard-line', label: 'Teclados y periféricos' },
  { icon: 'ri-battery-charge-line', label: 'Baterías y cargadores' },
  { icon: 'ri-router-line', label: 'Routers y cables' },
  { icon: 'ri-camera-line', label: 'Cámaras y equipos AV' },
];

const institutions = [
  {
    type: 'Colegios',
    icon: 'ri-book-open-line',
    color: '#1565c0',
    bg: '#e3f2fd',
    count: '240+',
    description: 'Colegios públicos y privados vinculados a nuestro programa de recolección en Santander',
  },
  {
    type: 'Universidades',
    icon: 'ri-graduation-cap-line',
    color: '#4527a0',
    bg: '#ede7f6',
    count: '18',
    description: 'Universidades e institutos de educación superior con puntos de acopio activos',
  },
  {
    type: 'Empresas',
    icon: 'ri-building-line',
    color: '#00695c',
    bg: '#e0f2f1',
    count: '80+',
    description: 'Empresas y entidades gubernamentales comprometidas con la disposición responsable de RAEE',
  },
];

const steps = [
  { num: '01', title: 'Registra tu institución', desc: 'Contáctanos para vincular tu colegio, universidad o empresa al programa de puntos de acopio.' },
  { num: '02', title: 'Instalamos el punto de acopio', desc: 'Entregamos contenedores señalizados y material educativo sobre la importancia del reciclaje electrónico.' },
  { num: '03', title: 'Recolección periódica', desc: 'Nuestro equipo visita la institución para recoger los aparatos acumulados de forma responsable.' },
  { num: '04', title: 'Disposición responsable', desc: 'Los equipos son clasificados: los funcionales se reparan o donan, el resto se recicla sin contaminar.' },
];

export default function ElectronicsSection() {
  return (
    <section className="w-full bg-[#f8fffe] py-24 px-6 md:px-14">
      {/* Header */}
      <div className="text-center mb-14">
        <span
          className="inline-flex items-center gap-2 text-[#00695c] text-[10px] tracking-[0.45em] uppercase font-semibold mb-3"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <i className="ri-recycle-line text-sm"></i>
          Programa RAEE
        </span>
        <h2
          className="text-[#1b5e20] font-bold leading-tight mb-4"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(2rem, 4vw, 3.2rem)',
          }}
        >
          Recepción de Aparatos<br />
          <span className="text-[#00897b]">Electrónicos en tu Institución</span>
        </h2>
        <p
          className="text-[#4a5568] text-base max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Los Residuos de Aparatos Eléctricos y Electrónicos (RAEE) son altamente contaminantes. Instalamos 
          <strong className="text-[#1b5e20]"> puntos de acopio gratuitos</strong> en colegios, universidades y empresas de Santander.
        </p>
      </div>

      <div className="max-w-6xl mx-auto">
        {/* Stats instituciones */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
          {institutions.map((inst) => (
            <div
              key={inst.type}
              className="rounded-2xl p-7 text-center"
              style={{ backgroundColor: inst.bg }}
            >
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: inst.color + '22' }}
              >
                <i className={`${inst.icon} text-2xl`} style={{ color: inst.color }}></i>
              </div>
              <div
                className="text-3xl font-bold mb-1"
                style={{ color: inst.color, fontFamily: "'Playfair Display', serif" }}
              >
                {inst.count}
              </div>
              <div
                className="text-sm font-bold mb-2"
                style={{ color: inst.color, fontFamily: "'Montserrat', sans-serif" }}
              >
                {inst.type}
              </div>
              <p
                className="text-[#4a5568] text-xs leading-relaxed"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {inst.description}
              </p>
            </div>
          ))}
        </div>

        {/* Main content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-14">
          {/* Left — What we accept */}
          <div>
            <h3
              className="text-[#1b5e20] font-bold text-xl mb-2"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              ¿Qué aparatos recibimos?
            </h3>
            <p
              className="text-[#6b7280] text-sm mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Aceptamos todo tipo de residuos electrónicos, independientemente del estado en que se encuentren:
            </p>
            <div className="grid grid-cols-2 gap-3">
              {acceptedItems.map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-3 bg-white rounded-xl p-4 hover:bg-[#e8f5e9] transition-colors duration-200"
                >
                  <div className="w-9 h-9 rounded-lg bg-[#e8f5e9] flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#2e7d32] text-base`}></i>
                  </div>
                  <span
                    className="text-[#374151] text-xs font-medium leading-tight"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Image + impact */}
          <div className="relative rounded-2xl overflow-hidden" style={{ minHeight: '360px' }}>
            <img
              src="https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/5db277f2-f0e0-44b3-8da0-2a5648c0c8b1_WhatsApp-Image-2026-04-19-at-12.04.00.jpeg?v=03d797d887b63d9d51b5d0d5df8ed91d"
              alt="Aparatos electrónicos para reciclaje RAEE Fundación Frais"
              className="w-full h-full object-cover"
              style={{ minHeight: '360px' }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1b5e20]/80 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="flex gap-4">
                <div className="text-center">
                  <div className="text-white text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                    4.2 Ton
                  </div>
                  <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    RAEE recolectadas
                  </div>
                </div>
                <div className="w-px bg-white/20"></div>
                <div className="text-center">
                  <div className="text-white text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                    0 Kg
                  </div>
                  <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    A vertederos
                  </div>
                </div>
                <div className="w-px bg-white/20"></div>
                <div className="text-center">
                  <div className="text-white text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                    338
                  </div>
                  <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Puntos activos
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="bg-[#1b5e20] rounded-2xl p-8 md:p-12">
          <h3
            className="text-white font-bold text-xl mb-2 text-center"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            ¿Cómo vincular tu institución?
          </h3>
          <p
            className="text-white/60 text-sm text-center mb-10"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            En 4 simples pasos, tu colegio o universidad tiene un punto de acopio activo
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step) => (
              <div key={step.num} className="text-center">
                <div
                  className="text-[#a5d6a7] text-4xl font-bold mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {step.num}
                </div>
                <h4
                  className="text-white font-bold text-sm mb-2"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {step.title}
                </h4>
                <p
                  className="text-white/55 text-xs leading-relaxed"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <a
              href="/contacto"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 text-xs md:px-8 md:py-3.5 md:text-sm bg-[#a5d6a7] text-[#1b5e20] font-bold tracking-widest uppercase rounded-full hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <i className="ri-send-plane-fill"></i>
              Vincular mi institución
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
